import { createTheme } from "@mui/material";
import { esES } from "@mui/x-date-pickers/locales";

export const heydoctorTheme = createTheme(
    {
        typography: {
            fontFamily: [
                "Manrope",
                "-apple-system",
                "BlinkMacSystemFont",
                '"Segoe UI"',
                "sans-serif",
            ].join(","),
            h1: { fontFamily: "'Montserrat', 'Manrope', sans-serif" },
            h2: { fontFamily: "'Montserrat', 'Manrope', sans-serif" },
            h3: { fontFamily: "'Montserrat', 'Manrope', sans-serif" },
            h4: { fontFamily: "'Montserrat', 'Manrope', sans-serif" },
            h5: { fontFamily: "'Montserrat', 'Manrope', sans-serif" },
            h6: { fontFamily: "'Montserrat', 'Manrope', sans-serif" },
            body1: {
                fontSize: "1rem",
                fontWeight: "500",
            },
        },
        palette: {
            primary: {
                main: "#4abcc9",
                contrastText: "#fff",
            },
            secondary: {
                main: "#257590",
            },
            mode: "light",
        },
        components: {
            MuiButton: {
                defaultProps: {
                    variant: "contained",
                    color: "primary",
                },
                styleOverrides: {
                    root: {
                        textTransform: "none",
                        //fontWeight: "bold",
                        fontSize: "1rem",
                    },
                },
            },
            MuiTextField: {
                defaultProps: {
                    variant: "outlined",
                    fullWidth: true,
                    color: "primary",
                },
            },
            MuiIconButton: {
                defaultProps: {
                    color: "primary",
                },
            },
            MuiDialogTitle: {
                defaultProps: {
                    fontWeight: "bold",
                },
            },
            MuiDialog: {
                defaultProps: {
                    scroll: "body",
                },
            },
            MuiTypography: {
                defaultProps: {
                    color: "textSecondary",
                    // fontSize: "1.1rem",
                    // fontWeight: "500",
                },
            },
        },
    },
    esES
);
